import { useAssistantStore } from '../stores/assistantStore.js';
import { useCallback } from 'react';
import { shallow as shallow$1 } from '../../../node_modules/zustand/esm/shallow.js';
import { pick } from 'lodash-es';
import { toast } from '../../store/alerts.js';

const useAskAssistantSelection = () => {
  const { setPersistentContext, setChatAssistantOpen } = useAssistantStore((state) => pick(state, [
    "setPersistentContext",
    "setChatAssistantOpen"
  ]), shallow$1);
  return useCallback((ids, added = false) => {
    if (added) {
      setPersistentContext((prev) => ({
        ...prev,
        resourceIds: [
          ...prev.resourceIds,
          ...ids
        ].filter((id, index, self) => self.indexOf(id) === index)
      }));
      toast({
        content: "Added to assistant context"
      });
    } else {
      setPersistentContext((prev) => ({
        ...prev,
        resourceIds: ids
      }));
      setChatAssistantOpen(true);
    }
  }, [
    setPersistentContext,
    setChatAssistantOpen
  ]);
};

export { useAskAssistantSelection };
//# sourceMappingURL=useAskAssistantSelection.js.map
